var Base = require('_js/base'),
  $ = require('jquery');

function BlockArticle() {
  this.init();
}

BlockArticle.prototype = new Base();

BlockArticle.prototype.init = function() {
  var $blockToTruncate = $('.article-block .block-text-container'),
    self = this;
  if ($blockToTruncate.get(0) !== undefined) {
    $(window).on('resize', function() {
      self.calculateHeightForTruncate($blockToTruncate);
    });
    self.calculateHeightForTruncate($blockToTruncate);
  }
};

BlockArticle.prototype.calculateHeightForTruncate = function(blockToTruncate) {
  // Get the height minus the padding, labels, heading and the readmore link.
  var height = blockToTruncate.outerHeight() - 80 - 45 - 90 - 40;
  // The minimum height is 60.
  if (height < 60) {
    height = 60;
  }
  blockToTruncate.each(function() {
    var $divContent = $(this).find('div.truncate');
    $divContent.css({ 'max-height': height });
    var $h3content = $(this).find('h3.truncate');
    $h3content.css({ 'max-height': height - 20 });
    var $divContent2 = $(this).find('div.truncate-2');
    $divContent2.css({ 'max-height': height });
    var $divContent3 = $(this).find('div.truncate-3');
    $divContent3.css({ 'max-height': height + 30 });
  });
};

module.exports = BlockArticle;
